<template>
  <v-list class="mb-2 mt-0 pt-0" height="46" v-if="!$auth.loading && $auth.isAuthenticated">
    <v-list-item>
      <v-list-item-avatar class="ml-n2 mt-3" >
        <v-img :src="$auth.user.picture"></v-img>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="body-2">{{ $auth.user.name }}</v-list-item-title>
        <v-list-item-subtitle class="caption">{{ $auth.user.email }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>

</style>